import $ from "jquery";
import Isotope from "isotope-layout"; 
import 'isotope-packery';
// npm install isotope-layout
// npm install isotope-packery

$(function() {
    $(".bl-werklist").each(function() {
        const $bl = $(this);

        //$bl.find(".item:lt(2)").addClass("sizebig"); //:lt(2) = first two

        const $guttersizer = $bl.find(".guttersizer");
        const guttersize = $guttersizer.width();

        const iso = new Isotope($bl.find(".ctritems").get(0), {
            layoutMode: 'packery',
            itemSelector: ".item",
            percentPosition: true, //smoother resize handling
            packery: {
                gutter: guttersize,
                columnWidth: '.columnsizer'
            }
        });

        const $filterbuttons = $bl.find(".ctrfilterbuttons");
        $filterbuttons.on("click", "a", function() {
            const $filterbutton = $(this);
            const requestedFilter = $filterbutton.data("filter");

            highlightFilterButton(requestedFilter);
            filterIsotope(requestedFilter);
        });

        function highlightFilterButton(requestedFilter) {
            $filterbuttons.find("a").removeClass("active");
            $filterbuttons.find("[data-filter='"+requestedFilter+"']").addClass("active");
        }

        function filterIsotope(requestedFilter) {
            if(requestedFilter == "*") {
                clearFilterIsotope();
                return;
            }

            iso.arrange({
                filter: ".filter-"+requestedFilter
            });
        }

        function clearFilterIsotope() {
            iso.arrange({
                filter: ""
            });
        }
    
        //mobile filter expand logic
        const $filterheader = $bl.find(".ctrfilterheader");
        $filterheader.on("click", function() {
            $filterheader.toggleClass("active");
            $filterbuttons.slideToggle({
                start: function () {
                    $(this).css('display', 'flex');
                },
                duration: 200
            });
        });
    });
});

